var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-group',{staticClass:"user-input",attrs:{"id":_vm.id,"label-for":_vm.id,"label":_vm.label}},[_c('b-form-input',{attrs:{"id":_vm.inputId,"value":_vm.model,"placeholder":_vm.placeholder,"required":_vm.required}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }